import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

// import WorkExperience from './sections/WorkExp';
import BasicInfo from './sections/BasicInfo';
// import Education from './sections/Education';
import Expertise from './sections/Expertise';
import {
  getCoachSubTopics,
  updateUserVerification,
} from '../../services/apiService';
import LoadingCircleIcon from '../../icons/LoadingCircle';
import RenderProfilePic from '../../extras/RenderProfilePic';
import {
  setProfileToVerify,
  verifyProfile,
} from '../../redux/actions/profileVerificationActions';
import { toast } from 'react-toastify';

const VerifyUser = ({ user }) => {
  const [data, setData] = useState({ id: user.id });
  const [loading, setLoading] = useState({});
  const [expertiseFormData, setExpertiseFormData] = useState([]);

  useEffect(() => {
    async function getCoach() {
      const data = await getCoachSubTopics(user.id);
      setExpertiseFormData(data);
    }
    getCoach();
  }, []);

  const dispatch = useDispatch();

  const goBack = () => dispatch(setProfileToVerify(null));

  const verifyUser = async () => {
    setLoading({ verify: true });

    try {
      dispatch(verifyProfile({ coachId: user.id, payload: expertiseFormData }));
      toast.success('Verification Updated Successfully');
    } catch (err) {
      toast.error('Verification Update Failed');
      console.error(err);
    }

    setLoading({ verify: false });
  };

  const holdUser = async () => {
    setLoading({ hold: true });

    try {
      await updateUserVerification({ id: user.id, status: 'hold' });
      toast.success('Coach Holded Successfully');
      goBack();
    } catch (err) {
      console.error(err);
      toast.error('Coach Holding Failed');
    }

    setLoading({ hold: false });
  };

  const verifyExpertise = (verifiedSubTopic, flag) => {
    const updatedExpertise = [
      ...expertiseFormData.map(({ createdAt, updatedAt, ...rest }) => rest),
    ];

    if (flag === 'approve') {
      updatedExpertise.splice(
        updatedExpertise.findIndex(
          (item) => item.subTopicId === verifiedSubTopic.subTopicId
        ),
        1
      );
      updatedExpertise.push({
        subTopicId: verifiedSubTopic.subTopicId,
        status: 'APPROVED',
      });
    } else if (flag === 'delete') {
      updatedExpertise.splice(
        updatedExpertise.findIndex(
          (item) => item.subTopicId === verifiedSubTopic.subTopicId
        ),
        1
      );
    }
    setExpertiseFormData(updatedExpertise);
  };

  return (
    <div className='font-medium text-gray-500'>
      {/* go back comp */}
      <div onClick={goBack} className='cursor-pointer mb-6'>
        <i className='fas fa-arrow-left mr-2' />
        <span>Back</span>
      </div>

      {/* main content */}
      <div className='bg-white rounded-lg p-8 grid gap-8'>
        {/* header */}
        <div className='flex items-center justify-between col-span-full'>
          <div className='flex items-center gap-4'>
            {/* profile pic */}
            <RenderProfilePic
              thumbnail={user.thumbnail}
              name={user.firstName}
            />

            {/* Name & id */}
            <div>
              <div className='text-gray-700 text-2xl font-semibold mb-2'>
                {user.firstName} {user.lastName}
              </div>
              <div className='text-sm'>User ID: {user.id}</div>
            </div>
          </div>

          {/* verification status */}
          {user.status === 'hold' ? (
            <span className='bg-red-600 text-white py-1 px-4 rounded'>
              Hold
            </span>
          ) : (
            <span className='bg-yellow-500 text-white py-1 px-4 rounded'>
              New
            </span>
          )}
        </div>

        <BasicInfo user={user} data={data} setData={setData} />

        {/* <WorkExperience
          workExperience={user.workExperience}
          newWorkExperience={user.newWorkExperience}
          data={data}
          setData={setData}
        />

        <Education
          education={user.education}
          newEducation={user.newEducation}
          data={data}
          setData={setData}
        /> */}

        <Expertise
          userSubTopics={expertiseFormData}
          verifyExpertise={verifyExpertise}
        />

        <div className='col-span-full flex justify-center gap-8'>
          <button
            onClick={verifyUser}
            disabled={loading.verify}
            className='bg-blue-500 text-white rounded py-2 w-56 focus:outline-none'
          >
            {loading.verify && <LoadingCircleIcon iconStyle='w-5 mr-2' />}
            Verify Now
          </button>

          {user.status !== 'hold' && (
            <button
              onClick={holdUser}
              disabled={loading.hold}
              className='border border-gray-300 rounded py-2 w-56 focus:outline-none'
            >
              {loading.hold && <LoadingCircleIcon iconStyle='w-5 mr-2' />}
              Keep On Hold
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyUser;
